
<template>
    <div class="center">
      <vs-dialog v-model="active">
        <template #header>
          <h4 class="not-margin">
              <span>Cancelar Pago</span>
          </h4>
        </template>


        <div class="con-form">
            <h6>El pago se encuentra timbrada para seguir deberá cancelar la factura existente de <strong>{{row.concepto}}</strong>.</h6>
            <h5>¿Quiere cancelar la factura y el pago?</h5>
        </div>

        <template #footer>
          <div class="footer-dialog" style="display:flex; justify-content: space-between">  
            <vs-button style="width: 30%" block danger class="color-red" @click="active = false">
              Cancelar
            </vs-button>
            <vs-button style="width: 30%" block success @click="getCancelarFactura()">
              Aceptar
            </vs-button>        
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import cobranza from '../../../../api/requests/cobranza-persona'
import profesor from '../../../../api/requests/landing-profesor'
    export default {
        props:[
          'value',
          'row',
          'institucion'
        ],
        data:() => ({
            active: false,
            concepto: ''
        }),
        methods:{
          async getCancelarFactura(){
              const loading = this.$vs.loading()
              try { 
                  const response = await cobranza.getCancelFactura(this.row.factura.uuid, this.institucion)
                  if(response.status === 200) {
                    this.active = false
                    this.$vs.notification({
                        progress: 'auto',                           
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa',
                        text: 'La factura ha sido cancelada'
                    })
                    this.cancelarPago()
                    loading.close()
                  }
              } catch (error) {
                    loading.close()
                  this.$vs.notification({
                      progress: 'auto',
                      color: 'danger',
                      position: null,
                      title: 'Error',
                      text: error.response.data.message
                  })
              }
          },
          async cancelarPago (id, categoria) {
            const loading = this.$vs.loading()
            try {
              let typeCategory = 'pago'

              const formData = new FormData();
              formData.append('pago', this.row.movimiento_id)
              formData.append('tipo', typeCategory)
              const response = await profesor.postSelectPagos(typeCategory, formData)
              if(response.data.response[0].status === 200){
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa',
                    text: 'El pago se ha cancelado'
                })
                this.$emit('refreshTable')
              }else{
                loading.close()
                this.$vs.notification({
                  progress: 'auto',
                  color: 'danger',
                  position: null,
                  title: 'Error',
                  text: 'Algo salió mal'
                })
              }
              this.$emit('refreshTable',true)
              this.active = false
            } catch(error) {
                loading.close()
                const response = error.response.data
                      if (response && response.errores){
                        const data = response.errores
                        let mensajes = Object.values(data)
                        if (Array.isArray(mensajes)){
                          mensajes.forEach(element => {
                              this.$vs.notification({
                                duration: 5000,
                                progress: 'auto',
                                color: 'danger',
                                position: null,
                                title: 'Error',
                                text: element 
                              })
                            
                          });
                        }else if (mensajes.descripcion){
                          this.$vs.notification({
                              duration: 5000,
                              progress: 'auto',
                              color: 'danger',
                              position: null,
                              title: 'Error',
                              text: mensajes.descripcion 
                          })
              
                          }else {
                              this.$vs.notification({
                                progress: 'auto',
                                duration: 5000,
                                color: 'warn',
                                position: null,
                                title: 'Warning',
                                text: `Algo salió mal`
                              })
                          }
                    }
            }
          },
        },
        watch: {
            value (val) {
                this.active = val
            },
            active (val) {
                if (!val){
                    this.$emit('input', val);
                }
            },
        }
    }
</script>
